<div class="flex items-center gap-4 w-full justify-between">
  <app-checkbox [formControl]="selected" />
  <div class="flex-1">
    <div class="flex items-center gap-2 mb-">
      <p class="text-base font-medium">Cupom de Procedimentos</p>
      <span
        class="px-2 py-1 text-xs font-medium rounded text-yellow-50 bg-yellow-500"
      >
        Expira em: {{ couponExpireAt() | date: 'dd/MM/yyyy' }}
      </span>
    </div>
    <p class="text-xs text-text-500 mt-1">
      Adquirido em: {{ couponCreatedAt() | date: 'dd/MM/yyyy' }}
    </p>

    <div class="mt-3 space-y-2">
      @for (procedure of procedures(); track procedure.id) {
        <app-user-coupon-procedure-item [procedure]="procedure" />
      }
    </div>
  </div>
</div>
